import { ContentContext, CountryContext } from 'Components/hooks/context';
import React, { useContext, useEffect, useState } from 'react';

import CumulativeChart from './CumulativeChart';
import NoteBox from 'Components/common/NoteBox';
import SmartTextIntro from './SmartText/Intro';
import SmartTextRate from './SmartText/Rate';
import VaccineRefferal from 'Components/common/VaccineReferral';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import fetchJson from 'Utils/fetchJson';

const Vaccination = (props) => {
  const { hasData, hasPopData } = props;
  const [data, setData] = useState(null);

  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);

  useEffect(() => {
    if (!hasData) return;
    const fetchData = async() => {
      const data = await fetchJson(`https://graphics.thomsonreuters.com/data/2020/coronavirus/owid-covid-vaccinations/countries/${countrySlug}/data.json`);
      setData(data);
    };
    fetchData();
  }, [countrySlug, hasData]);

  if (!hasData || !data || !content.template.vaccination) return null;

  return (
    <div className={classnames(component)}>
      <section> <VaccineRefferal /> </section>
      {hasPopData &&
        <>
          <section>
            <h4>{content.template.vaccination.title}</h4>
            <SmartTextIntro vaccinationData={data} />
          </section>
          <NoteBox
            title={content.template.vaccination.infobox.title}
            source={content.template.vaccination.infobox.text}
          />
          <section>
            <CumulativeChart
              vaccinationData={data}
            />
            <SmartTextRate vaccinationData={data} />
          </section>
        </>
      }
    </div>
  );
};

export default Vaccination;
